import queryString from 'query-string';
import { getConfigJson } from 'src/api/config';
import { setQueryParams } from 'src/services/query-params/query-params';
import type { ParsedQueryParams } from 'src/types/general';

export const initQueryParams = async () => {
  const params = queryString.parse(window.location.search, {
    parseNumbers: true,
    parseBooleans: true,
  }) as unknown as Partial<ParsedQueryParams>;

  setQueryParams(params);
};

export const initEnvConfig = async () => {
  const config = await getConfigJson();

  Object.defineProperty(window, 'ENV_CONFIG', {
    value: Object.freeze(config),
    writable: false,
  });
};
